import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * Table class.
 */
export default class Table extends Base {
  /**
   * Table options.
   */
  get config() {
    return {
      name: 'Table',
      log: isDev(),
    };
  }

  /**
   * Mounted
   */
  mounted() {
    this.titles = Array.from(this.$el.querySelectorAll('thead tr th')).map((th) => th.innerText);
    this.rows = this.$el.querySelectorAll('tbody tr');
    this.rows.forEach((tr) => {
      Array.from(tr.children).forEach((td, index) => {
        if (typeof this.titles[index] !== 'undefined') {
          td.dataset.title = this.titles[index];
        }
      });
    });
    this.$destroy();
  }
}
